import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DashboardComponent } from './dashboard.component';
import { AuthGuard} from './../shared/guard/auth.guard';
import { OrdersResolver} from './orders.resolver';
import { UserResolver} from './user.resolver';
import { AutofillEligibilityResolver } from './autofill-eligibility.resolver';

export const routes: Routes = [
  {
    path: '',
    component: DashboardComponent,
    resolve: {
      user: UserResolver,
      orders: OrdersResolver,
      autofill: AutofillEligibilityResolver
    },
    runGuardsAndResolvers: 'always',
    children: [
      {
        path: 'orders',
        loadChildren: () => import('./orders-tab/orders-tab.module').then(m => m.OrdersTabModule),
        canActivate: [AuthGuard],
        data: {
          tab: true,
          default: true,
          label: {
            name: 'orders',
            ariaLabel: '',
            dynValue: ''
          }
        }
      },
      {
        path: 'medications',
        loadChildren: () => import('./medications-tab/medications-tab.module').then(m => m.MedicationsTabModule),
        canActivate: [AuthGuard],
        data: {
          tab: true,
          label: {
            name: 'medications',
            ariaLabel: '',
            dynValue: ''
          }
        }
      },
      {
        path: 'settings',
        loadChildren: () => import('./settings-tab/settings-tab.module').then(m => m.SettingsTabModule),
        canActivate: [AuthGuard],
        data: {
          tab: true,
          label: {
            name: 'settings',
            ariaLabel: '',
            dynValue: ''
          }
        }
      },
      {
        path: 'order-details',
        loadChildren: () => import('./order-details/order-details.module').then(m => m.OrderDetailsModule),
        canActivate: [AuthGuard],
        data: {
          hidetabs: false
        }
      },
      {
        path: 'order-details/:orderId/:status',
        loadChildren: () => import('./order-details/order-details.module').then(m => m.OrderDetailsModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'medication-details/:orderId/:status/:rxNumber',
        loadChildren: () => import('./order-item-details/order-item-details.module').then(m => m.OrderItemDetailsModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'order-details/:orderId/:status/:rxNumber',
        loadChildren: () => import('./order-item-details/order-item-details.module').then(m => m.OrderItemDetailsModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'order-history',
        loadChildren: () => import('./order-history/order-history.module').then(m => m.OrderHistoryModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'order-history/:orderId/:status',
          loadChildren: () => import('./order-history-details/order-history-details.module').then(m => m.OrderHistoryDetailsModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'sync-plan',
        loadChildren: () => import('./sync-plan/sync-plan.module').then(m => m.SyncPlanModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'autofill',
        loadChildren: () => import('./autofill-enrollment/autofill-enrollment.module').then(m => m.AutofillEnrollmentModule),
        canActivate: [AuthGuard],
        data: {
          title: 'CVS Pharmacy | Multi Dose Packaging Dashboard AutoFill Options'
        }
      },
      {
        path: '',
        redirectTo: '',
        pathMatch: 'full'
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DashboardRoutingModule { }
